export type AgentApiConfig =
  | { mode: 'real'; baseUrl: string }
  | { mode: 'mock' }
  | { mode: 'off' };

/**
 * Reads VITE_AGENT_API_URL. A URL talks to odin-agents; "mock" plays scripted
 * events, in development builds only, so fixtures never reach a deployed build;
 * unset or blank turns the panel off.
 */
export function readAgentApiConfig(
  raw: string | undefined,
  isDev: boolean,
): AgentApiConfig {
  const value = raw?.trim() ?? '';
  if (!value) return { mode: 'off' };
  if (value === 'mock') return isDev ? { mode: 'mock' } : { mode: 'off' };
  return { mode: 'real', baseUrl: value.replace(/\/+$/, '') };
}
